import VerifyWarriorsWallet from '~/components/auth/VerifyWallet';
import Button from '~/components/common/Button';
import NamingWarriorList from '~/components/naming/NamingWarriorList';
import MainNav from '~/components/navbar/MainNav';
import { ConnectedProviders } from '~/contextProviders/connectedProviders';
import { useGameAuthentication } from '~/contextProviders/GameAuthenticationProvider';
import { useWarriorAuthentication } from '~/contextProviders/WarriorAuthenticationProvider';

const NamePage = () => {
  const { warriors, isLoading, hasMore, isLoadingMore, loadMore } =
    useWarriorAuthentication();
  const { accessToken } = useGameAuthentication();

  return (
    <div className="container container--landing-page container--revival">
      <header className="landing-page__header">
        <MainNav showConnectWallet={true} />
      </header>
      <div
        className={`content-wrapper ${
          warriors && warriors.length ? '' : 'content-wrapper--naming'
        }`}
      >
        <h2 className="landing-page__h2 landing-page__h2--amarante naming-title-spacing">
          Name thy Warriors
        </h2>
        {warriors && warriors.length ? (
          <div className="naming-title-spacing">
            Choose wisely, you can only name your Warrior once
          </div>
        ) : (
          <></>
        )}
        <>
          {accessToken ? (
            <>
              {(isLoading || isLoadingMore) && <div>Loading Warriors...</div>}
              {!(isLoading || isLoadingMore) && !warriors?.length && (
                <div>You don&apos;t own any Warriors</div>
              )}
              <NamingWarriorList warriors={warriors} />
              {hasMore && (
                <div className="revival__load-more">
                  <Button
                    label={isLoadingMore ? 'Loading...' : 'Load More'}
                    onClick={loadMore}
                    disabled={isLoadingMore}
                    className="warrior__attack__confirm__button warrior__attack__confirm__button--more primary"
                  />
                </div>
              )}
            </>
          ) : (
            <div className="name-wallet-connect">
              <VerifyWarriorsWallet />
            </div>
          )}
        </>
      </div>
    </div>
  );
};

const Name = () => {
  return (
    <ConnectedProviders accessTokenRequired={true}>
      <NamePage />
    </ConnectedProviders>
  );
};

export default Name;
